import { Box, Stack, Typography } from '@mui/material';
import Logo from 'src/components/Logo';
import { ListCCIcon } from "../../assets";
import { useTheme } from "@mui/material/styles";

interface Props {
    type: 'login' | 'register';
}

const AuthWelcomeBanner: React.FC<Props> = ({ type }: Props) => {
  const theme = useTheme();

  const typeToListItems = new Map([
      ['login', [
            'See your impact grow',
            'Analyse stakeholder engagement',
            'Review digital marketing assets & messaging guidelines',
            'Explore what more you can do to tackle residual emissions & engage your audience',
            'Demonstrate your impact'
      ]],
      ['register', [
            'Access a highly vetted portfolio of climate projects',
            'Calculate emissions',
            'Offset emissions - individually & in bulk',
            'Create & integrate offset programmes ',
            'Leverage digital marketing assets & messaging guidelines '
      ]]
  ])

  return (
    <Stack className="container" sx={{ marginLeft: '15% !important' }} spacing={{ xs: 0.5, lg: 0.5 }}>
        <Stack spacing={{ xs: 4, lg: 5.5 }}>
          <Logo sx={{ '& img': { height: 75 } }} />
          <Typography variant="title1">Towards a cooler planet.</Typography>
          <Typography sx={{ fontSize: '1.6rem', width: '40vw' }}>
              {type === 'login' ? 'Welcome back.' : 'Your tool to make transparent, credible carbon offsetting a part of your climate action toolkit.'}
          </Typography>
          <Typography sx={{ fontSize: '1.6rem', marginTop: '1rem !important', color: theme.palette.primary.main }}>
              {type === 'login' ? 'Sign in to' : 'Sign up to'}
          </Typography>
        </Stack>

        {typeToListItems.get(type)?.map((item, index) => (
            <Box key={index} sx={{ width: '40vw', display: 'flex', fontSize: '1.2rem', marginTop: index === 0 ? '2.5rem !important' : 'unset' }}>
                <ListCCIcon style={{ width: '15px', height: '15px', marginRight: '12px' }}/>
                {item}
            </Box>
        ))}
    </Stack>
  );
};

export default AuthWelcomeBanner;
